const UiSelectPropsOption = {
  classExtraName: { type: String },
  placeholder: { type: String },
  modelValue: { required: true },
  widthExtra: { type: Number },
  candidates: { type: Array, required: true },
  clearable: { type: Boolean, default: false },
  //* 清空按钮是否显示
  animation: { type: Boolean, default: true },
  //* 过渡动画是否开启
  disabled: { type: Boolean, default: false },
  //* 选择器是否禁用
  readonly: { type: Boolean, default: false },
  //* 选择器是否只读
  loading: { type: Boolean, default: false },
  //* 选择器内置加载器是否开启
  resolve: { type: Function },
  //* 选择器文本解析控制器
  height: { type: Number, default: 240 },
  zIndex: { type: Number, default: 66 },
  width: { type: [String, Number], default: 264 },
  size: { type: String, default: "default" },
  name: { type: String }
};
const UiSelectEmits = {
  "update:modelValue": (_ev) => true,
  "before-enter": () => true,
  "before-leave": () => true,
  "after-enter": () => true,
  "after-leave": () => true,
  "change": (_ev) => true,
  "clear": (_ev) => true
};

export { UiSelectEmits, UiSelectPropsOption };
//# sourceMappingURL=index.mjs.map
